import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'

export default function SortBtns(props: {
  isDesc?: boolean
  sortBy: string
  value?: string
  onSort?: (isDesc: boolean, sortBy: string) => void
}) {
  const { isDesc, sortBy, value } = props

  const onDescSort = () => {
    if (isDesc && sortBy === value) {
      return true
    }
    return undefined
  }

  const onAscSort = () => {
    if (!isDesc && sortBy === value) {
      return true
    }
    return undefined
  }

  return (
    <div className='sort-btns'>
      <CaretUpOutlined
        style={{ color: onAscSort() ? '#FF0000' : '#D3D3D3' }}
        onClick={() => props.onSort && props.onSort(false, sortBy)}
      />
      <CaretDownOutlined
        style={{ color: onDescSort() ? '#FF0000' : '#D3D3D3' }}
        onClick={() => props.onSort && props.onSort(true, sortBy)}
      />
    </div>
  )
}
